/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class SignalRConnection {
        connection: signalR.HubConnection;

        constructor(url: string) {
            this.connection = new signalR.HubConnectionBuilder().withAutomaticReconnect([100, 500, 1000, 1500, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000]).withUrl(url, {
                //skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            }).build();

       
        }

        on(key: string, fn: (...args: any[]) => void) {
            this.connection.on(key, fn);
        }

        onDisconnect(fn: (error?: Error) => void) {
            this.connection.onreconnecting(fn);
        }
        onReconnected(fn: (connectionId: string) => void) {
            this.connection.onreconnected(fn)
        }

        start(transport: signalR.HttpTransportType, callback: () => void) {
            console.log("Transport:",transport);

            //auto
            if (transport == signalR.HttpTransportType.None) transport = signalR.HttpTransportType.WebSockets;


            //if (transport == signalR.HttpTransportType.WebSockets) {
                setInterval(async () => {
                    if ((this.connection.state as any) == "Connected") {
                        await this.connection.invoke("Ping");
                    }

                }, 5000);
            //}

            (this.connection as any).connection.options.transport = transport;
            this.connection.start().then(callback);
        }
    }
}